module.exports = __webpack_public_path__ + "media/images/knockout__pickarrow@3x-1552c0317fb1b51d8d08c8f7a94999e8.png";